import React from 'react';

import { cn } from '@nfctron/nexus-react';

import { ChevronRightIcon } from 'lucide-react';
import Link from 'next/link';

import { APP_I18N_NAMESPACE } from '@root/lib/constants/common';
import { useTranslate } from '@root/lib/hooks/useTranslation';

import { type FancyLinkProps } from './FancyLink.types';

/**
 * FancyLink component
 * @author filipditrich <ditrich@nfctron.com>
 * @constructor
 */
export const FancyLink: React.FunctionComponent<React.PropsWithChildren<FancyLinkProps>> = (props) => {
	const { as, children, Icon = ChevronRightIcon, className, href, target, ...rest } = props;
	const { t } = useTranslate(APP_I18N_NAMESPACE.COMMON);

	if (as === 'span') {
		return (
			<span className={cn('group/link block', className)} {...rest}>
				<span className="inline">
					{children}
					<Icon
						size={15}
						className="text-md ml-0.5 inline-block opacity-75 transition-all duration-300 ease-out group-hover/link:translate-x-0.5 group-hover/link:opacity-100"
					/>
				</span>
			</span>
		);
	}

	return (
		<Link className={cn('group/link block', className)} href={href} target={target} {...rest} ref={rest.ref as any}>
			<span className="inline">
				{children}
				<Icon
					size={15}
					className="text-md ml-0.5 inline-block opacity-75 transition-all duration-300 ease-out group-hover/link:translate-x-0.5 group-hover/link:opacity-100"
				/>
			</span>
		</Link>
	);
};

/**
 * FancyLink component display name
 * @type {ComponentDisplayName}
 */
FancyLink.displayName = 'component/FancyLink';
